<template>
  <div>
    <div id="followerTabs">
      <mu-row>
        <mu-col v-for="tab, tabIndex in tabs" :key="'follower-tab-' + tabIndex" tablet="50" desktop="50" width="50">
          <router-link class="tab" :to="tab.route" v-text="tab.label"></router-link>
        </mu-col>
      </mu-row>
    </div>
    <mu-card>
      <mu-list>
        <mu-list-item class="item" v-for="item, index in items" :key="'item-' + index" disableRipple>
          <p slot="title" @click="goToProfile(item.profile_id)">
            {{item.display_name}}
          </p>
          <mu-avatar @click="goToProfile(item.profile_id)" :src="item.profile_large" slot="leftAvatar"/>
          <div slot="describe">
            <span v-text="item.diabetes_type"></span>
          </div>
          <mu-flat-button
            :disabled="item.is_sending === true"
            v-if="!item.is_own_profile"
            class="followBtn"
            slot="right"
            :class="{'following' : item.is_following}"
            :icon="item.is_following ? 'person' : 'person_add'"
            :label="item.is_following ? 'Unfollow' : 'Follow'"
            @click.native="followUser(item)"
            primary>
          </mu-flat-button>
        </mu-list-item>
      </mu-list>
    </mu-card>
  </div>
</template>

<script>

  import ProfileApi from "../../../api/Profile";
  import _ from "lodash";

  export default {
    name: 'follower-item',
    props: {
        items: {
          type: Array,
          required: true
        },
        type: {
          type: String,
          required: true
        }
    },
    data () {
      return {
        tabs: [
          {
            label: "Followers",
            route: 'followers',
          },
          {
            label: "Following",
            route: 'following',
          },
        ]
      }
    },
    methods: {
      followUser(item) {
        let self = this, follow_id = null;
        item.is_sending = true;
        self.$forceUpdate();
        if( self.type === 'following' ) {
          follow_id = item.follow_id;
        } else if ( self.type === 'followers' ) {
          follow_id = item.user_id;
        }
        if( follow_id !== null ) {
          ProfileApi.follow({follow_id: follow_id}).then((response) => {
            let callback = response.data;
            if(callback.isFollowing) {
              item.is_following = true;
            } else {
              item.is_following = false;
            }
            item.is_sending = false;
          }).catch((error) => {
            self.$toastr.error(error.response.data.message);
            item.is_sending = false;
          });
        }
      },
      goToProfile(profileUrl) {
        let self = this;
        self.$router.push({
          name: 'Profile',
          params: {
            profileUrl: profileUrl,
          }
        })
      }
    },
    computed: {
      isOwnProfile() {
        let self = this;
        if (_.has(self.$store.state.user, 'scope')) {
          return self.$store.state.activeProfile === self.$store.state.user.scope.user_id;
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// FollowerItem.vue?7b7f5e0e